import { css } from 'styled-components';

export const scrollHorizontalInvisible = css`
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
